import React from 'react';

const SalesDetailListTable = ({ title = "사업 유형별 상세 리스트" }) => {
    // 💡 임원진 보고 및 화면 검증용 예비 데이터 (Dummy Data)
    const dummyListData = [
        { month: '03월', name: '⚡ 글로벌 통합 차세대 ERP 구축 사업', sales: 250000000, profit: 62500000, owner: '홍길동 팀장' },
        { month: '05월', name: '☁️ 클라우드 기반 스마트 팩토리 고도화', sales: 180000000, profit: 45000000, owner: '이순신 과장' },
        { month: '07월', name: '📊 빅데이터 파이프라인 및 BI 대시보드 수립', sales: 120000000, profit: 30000000, owner: '강감찬 차장' },
        { month: '09월', name: '🔐 공공기관 전사 보안 관제 솔루션 패키징', sales: 50000000, profit: 12500000, owner: '유관순 대리' },
    ];

    return (
        /* 좌측 차트들과 디자인 톤앤매너(테두리, 라운딩)를 통일한 카드 프레임 */
        <div style={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            background: '#ffffff', 
            border: '1px solid #E2E8F0', 
            borderRadius: '12px', 
            overflow: 'hidden', 
            boxSizing: 'border-box' 
        }}>
            {/* 1. 상단 헤더 영역 */}
            <div style={{ 
                padding: '10px 16px', 
                backgroundColor: '#F1F5F9', 
                borderBottom: '1px solid #E2E8F0', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                boxSizing: 'border-box'
            }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#334155', letterSpacing: '-0.3px' }}>
                    {title}
                </div>
                <span style={{ fontSize: '11px', fontWeight: '700', color: '#1E3A8A', backgroundColor: '#EFF6FF', padding: '2px 8px', borderRadius: '4px' }}>
                    총 {dummyListData.length}건
                </span>
            </div>

            {/* 2. 하단 테이블 바디 영역 (데이터가 많아질 경우를 대비해 스크롤 적용) */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '12px', boxSizing: 'border-box' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', tableLayout: 'fixed' }}>
                    <thead>
                        <tr style={{ borderBottom: '2px solid #E2E8F0', backgroundColor: '#F8FAFC' }}>
                            <th style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#475569', width: '60px', textAlign: 'center' }}>매출월</th>
                            <th style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#475569', width: '40%' }}>사업명</th>
                            <th style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#475569', textAlign: 'right' }}>매출액</th>
                            <th style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#475569', textAlign: 'right' }}>매출 이익</th>
                            <th style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#475569', width: '85px', textAlign: 'center' }}>담당자</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dummyListData.map((row, idx) => (
                            <tr 
                                key={idx} 
                                style={{ borderBottom: '1px solid #F1F5F9', transition: 'background 0.15s' }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F8FAFC'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                                {/* 매출월 컬럼 */}
                                <td style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '600', color: '#64748B', textAlign: 'center' }}>
                                    {row.month}
                                </td>
                                
                                {/* 사업명 컬럼 (글자가 길어지면 깨지지 않고 말줄임표 처리되도록 방어) */}
                                <td 
                                    style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#1E293B', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} 
                                    title={row.name}
                                >
                                    {row.name}
                                </td>
                                
                                {/* 매출액 컬럼 */}
                                <td style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#0F172A', textAlign: 'right' }}>
                                    {row.sales.toLocaleString()}원
                                </td>
                                
                                {/* 매출 이익 컬럼 */}
                                <td style={{ padding: '10px 8px', fontSize: '12px', fontWeight: '700', color: '#10B981', textAlign: 'right' }}>
                                    {row.profit.toLocaleString()}원
                                </td>
                                
                                {/* 담당자 컬럼 */}
                                <td style={{ padding: '10px 8px', fontSize: '11px', fontWeight: '600', color: '#475569', textAlign: 'center' }}>
                                    {row.owner}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SalesDetailListTable;
